/**
 * URL de imagem estática para prévia de mapa (estilo WhatsApp).
 * Com REACT_APP_GOOGLE_STATIC_MAPS_API_KEY usa Google Static Maps.
 * Sem chave: um tile raster do OpenStreetMap (staticmap.openstreetmap.de costuma falhar em DNS).
 */
function lonLatToTileXY(lon, lat, zoom) {
  const latRad = (lat * Math.PI) / 180;
  const n = 2 ** zoom;
  const x = Math.floor(((lon + 180) / 360) * n);
  const y = Math.floor(
    ((1 - Math.log(Math.tan(latRad) + 1 / Math.cos(latRad)) / Math.PI) / 2) * n
  );
  return { x, y, z: zoom };
}

const OSM_SUBS = ["a", "b", "c"];

export function buildStaticMapPreviewUrl(lat, lng, options = {}) {
  const latN = Number(lat);
  const lngN = Number(lng);
  if (!Number.isFinite(latN) || !Number.isFinite(lngN)) return null;

  const key =
    typeof process !== "undefined" && process.env?.REACT_APP_GOOGLE_STATIC_MAPS_API_KEY
      ? String(process.env.REACT_APP_GOOGLE_STATIC_MAPS_API_KEY).trim()
      : "";
  if (key) {
    const w = options.width ?? 400;
    const h = options.height ?? 200;
    const center = `${latN},${lngN}`;
    const size = `${Math.min(640, w)}x${Math.min(640, h)}`;
    const params = new URLSearchParams({
      center,
      zoom: String(options.zoom ?? 15),
      size,
      scale: "2",
      markers: `color:0xE53935|${center}`,
      key,
    });
    return `https://maps.googleapis.com/maps/api/staticmap?${params.toString()}`;
  }

  const z = Math.min(19, Math.max(0, Math.round(Number(options.zoom ?? 15))));
  const { x, y, z: zz } = lonLatToTileXY(lngN, latN, z);
  const sub = OSM_SUBS[Math.abs((x + y + zz) % OSM_SUBS.length)];
  return `https://${sub}.tile.openstreetmap.org/${zz}/${x}/${y}.png`;
}
